import { css } from '@emotion/core'
import theme from 'Theme'
import { smallOnly, mediumUp } from 'Utils'

export default () => {
  const { colors, typography, spacing } = theme

  return css`
    .list__title {
      display: table;
      margin: 0 auto ${spacing.vertical.small} auto;
      font-size: ${typography.sizes.larger};
      letter-spacing: ${typography.headings.subHeadLetterSpacing};
      line-height: 1em;
      font-weight: bold;
      color: ${colors.primary};
      @media ${mediumUp} {
        font-size: ${typography.sizes.larger};
      }
    }

    .list__sub-title {
      font-weight: normal;
      text-align: center;
      font-family: ${typography.body.fontFamily};
      font-size: ${typography.sizes.small};
      display: table;
      margin: 0 auto ${spacing.vertical.medium} auto;
      line-height: 1.2em;
      @media ${smallOnly} {
        max-width: 475px;
      }
      @media ${mediumUp} {
        font-size: ${typography.baseFontSize};
      }
    }

    .content {
      text-transform: uppercase;
    }

    .heading {
    }

    .heading {
      font-size: ${typography.sizes.larger};
      @media ${mediumUp} {
        font-size: ${typography.sizes.larger};
      }
    }
  `
}
